import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { usePersistedState } from "@/hooks/usePersisted";

const Ctx = createContext(null);

export function RiggingSiteProvider({ children }) {
  const [sites, setSites] = useState([]);
  const [siteId, setSiteId] = usePersistedState("rig:site", "all");

  const reload = useCallback(() => { api.get("/rigging/sites").then(setSites).catch(() => setSites([])); }, []);
  useEffect(() => { reload(); }, [reload]);

  // If the stored site no longer exists, fall back to "all".
  useEffect(() => {
    if (siteId !== "all" && sites.length && !sites.some((s) => s.id === siteId)) setSiteId("all");
  }, [sites, siteId, setSiteId]);

  const siteParam = siteId && siteId !== "all" ? `?site_id=${siteId}` : "";
  const siteName = siteId === "all" ? "All sites" : (sites.find((s) => s.id === siteId)?.name || "All sites");

  return <Ctx.Provider value={{ sites, siteId, setSiteId, reload, siteParam, siteName }}>{children}</Ctx.Provider>;
}

export const useRiggingSite = () => useContext(Ctx) || { sites: [], siteId: "all", setSiteId: () => {}, reload: () => {}, siteParam: "", siteName: "All sites" };
